import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

export default function AnimatedBadge({ children, className = "" }) {
  const { theme } = useTheme();

  const brandColor = theme === 'dark' ? '#F97316' : '#3B82F6';

  return (
    <div className={`relative inline-flex items-center justify-center p-[1px] overflow-hidden rounded-full ${className}`}>
      {/* The "Spinner" Background - Single Color to Transparent */}
      <div 
        className="absolute inset-[-1000%] animate-[spin_4s_linear_infinite]"
        style={{
          background: `conic-gradient(from 90deg at 50% 50%, #F97316 0%, #3B82F6 25%, transparent 50%, transparent 100%)`
        }}
      ></div>
      
      {/* The Masking Foreground */}
      <div 
        className="relative flex items-center gap-2 px-3 py-1.5 rounded-full bg-background/95 backdrop-blur-xl font-bold text-[10px] uppercase tracking-widest border border-foreground/5 transition-colors duration-300"
        style={{ color: brandColor }}
      >
        {children}
      </div>
    </div>
  );
}
